// router/index.ts
import { createRouter, createWebHistory, type RouteRecordRaw, RouterView } from 'vue-router'
import { h } from 'vue'
import { useRoute } from 'vue-router'

// --- Seiten ---
import HomeDe from '@/pages/de/HomePage.vue'
import PayDe from '@/pages/de/PayPage.vue'
import LegalDe from '@/pages/de/LegalPage.vue'
import SelectDe from '@/pages/de/SelectAppointment.vue'
import AGBsPageDe from "@/pages/de/AGBsPage.vue";

import HomeEn from '@/pages/en/HomePage.vue'
import PayEn from '@/pages/en/PayPage.vue'
import LegalEn from '@/pages/en/LegalPage.vue'
import SelectEn from '@/pages/en/SelectAppointment.vue'
import AGBsPageEn from "@/pages/en/AGBsPage.vue";

// Layout ohne Template-String (kein Runtime-Compiler nötig)
const LangLayout = { render: () => h(RouterView) }

// Wrapper: wählt Component anhand von :lang
function makeLangComponent(deComp: any, enComp: any) {
  return {
    setup() {
      const route = useRoute()
      return () => h(route.params.lang === 'en' ? enComp : deComp)
    },
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang(de|en)',
    component: LangLayout,
    children: [
      // Home: gleicher (leerer) Pfad
      { path: '', name: 'home', component: makeLangComponent(HomeDe, HomeEn), meta: { title: 'Pay R' } },

      // Appointment: unterschiedliche Slugs pro Sprache
      // /de/termin   oder  /en/appointment
      {
        path: ':term(termin|appointment)',
        name: 'appointment',
        component: makeLangComponent(SelectDe, SelectEn),
        meta: { title: 'Pay R' },
      },

      // Pay: gleicher Pfad "`https://pay-r/${locale}/pay?appointmentID=${appointmentId}__d=${duration}__t=${type}__r=${restbetrag}`"
      {
        path: 'pay/:a?/:s?/:d?/:t?/:r?/:o?',
        name: 'pay',
        component: makeLangComponent(PayDe, PayEn),
        meta: { title: 'Pay R' },
      },

      // Legal/Impressum: unterschiedliche Slugs
      // /de/datenschutz-impressum   oder  /en/data-protection-imprint
      {
        path: ':legal(datenschutz-impressum|data-protection-imprint)',
        name: 'legal',
        component: makeLangComponent(LegalDe, LegalEn),
        meta: { title: 'Pay R' },
      },
      {
        path: ':agb(agb|t-and-c)',
        name: 'agb',
        component: makeLangComponent(AGBsPageDe, AGBsPageEn),
        meta: { title: 'Pay R' },
      },
    ],
  },

  // Root → Standard-Sprache
  { path: '/', redirect: '/de' },

  // Fallback
  { path: '/:catchAll(.*)', redirect: '/de' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

// Optional: absichern, dass :lang nur de|en ist
router.beforeEach((to) => {
  const lang = to.params.lang as string | undefined
  if (lang && !['de', 'en'].includes(lang)) return { path: '/de' }
})

router.afterEach((to) => {
  document.title = (to.meta?.title as string) || 'Pay R'
})

export default router
